import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'platform-info-bar',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="info-bar-container">
            <i [class]="icon" [ngStyle]="{ color: iconColor }"></i>
            <span class="info-message">{{ message }}</span>
        </div>
    `,
    styles: [
        `
            .info-bar-container {
                display: flex;
                align-items: center;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                background-color: #f0f5ff;
                color: #1f3e72;
                font-family: 'IBM Plex Sans', sans-serif;
                font-size: 1rem;
                border: 1px solid #dde7f6;
                max-width: 100%;
            }

            .info-bar-container i {
                margin-inline: 0.5rem;
                font-size: 1.25rem;
            }

            .info-message {
                font-weight: 400;
                color: #333;
            }
        `,
    ],
})
export class InfoBarComponent {
    @Input() icon: string = 'pi pi-info-circle'; // Default icon
    @Input() iconColor: string = '#1f3e72'; // Default color for icon
    @Input() message: string = '20 tasks have been selected for reassignment';
}
